"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultDateFormatter = defaultDateFormatter;
exports.defaultDateTimeFormatter = defaultDateTimeFormatter;

var _moment = _interopRequireDefault(require("moment"));

/**
 * 格式化相关工具
 */
// 日期时间默认格式化字符串
var DEFAULT_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'; // 日期默认格式化字符串

var DEFAULT_DATE_FORMAT = 'YYYY-MM-DD'; // ISO 8601 测试正则，仅测试包含时间的，如 2020-10-21T06:40:05Z

var DATE_TIME_ISO8601 = /^\d{4}-\d{1,2}-\d{1,2}T\d{1,2}:\d{1,2}:\d{1,2}/;
/**
 * 格式化时间
 *
 * 如果是字符串，如果是 iso 8601 格式的，转为 moment 对象，否则直接返回；
 * 如果是数字，认为是时间戳，转为 moment 对象；
 * 如果是 moment 对象，那么调用其 format 方法，否则直接返回其自身
 *
 * @param {Moment | *} m moment 对象或任意值
 * @param {string} fmt 格式化字符串，参考 https://momentjs.com/docs/#/parsing/string-format/
 * @returns {null|*}
 */

function formatTime(m, fmt) {
  if (!m) return null;

  if (typeof m === 'string') {
    if (DATE_TIME_ISO8601.test(m)) {
      m = (0, _moment.default)(m);
    } else {
      return m;
    }
  }

  if (typeof m === 'number') {
    m = (0, _moment.default)(m);
  }

  return typeof m.format === 'function' ? m.format(fmt) : m;
}
/**
 * 日期时间默认格式化函数
 * @param m
 * @returns {*}
 */


function defaultDateTimeFormatter(m) {
  return formatTime(m, DEFAULT_DATE_TIME_FORMAT);
}
/**
 * 日期默认格式化函数
 * @param m
 * @returns {*}
 */


function defaultDateFormatter(m) {
  return formatTime(m, DEFAULT_DATE_FORMAT);
}